/* eslint-disable no-param-reassign */
import produce from 'immer';
import getInitialState from './getInitialState';
var markerGenesError = produce(function (draft) {
  draft.markers.loading = false;
  draft.markers.error = true;
  draft.markers.requestSignature = null;
}, getInitialState());
export default markerGenesError;